import { lazy } from 'react';
import { caseStudiesData } from '../data/caseStudiesData';

const Fitmama = lazy(() => import('../pages/case-studies/Fitmama'));
const Hats = lazy(() => import('../pages/case-studies/Hats'));
const Tycoon = lazy(() => import('../pages/case-studies/Tycoon'));
const UniverseQueen = lazy(() => import('../pages/case-studies/UniverseQueen'));
const TruckAndFins = lazy(() => import('../pages/case-studies/TruckAndFins'));
const PlayOn = lazy(() => import('../pages/case-studies/PlayOn'));
const ProfessionalScopists = lazy(() => import('../pages/case-studies/ProfessionalScopists'));
const Washup = lazy(() => import('../pages/case-studies/Washup'));

const componentBySlug = {
  fitmama: Fitmama,
  hats: Hats,
  tycoon: Tycoon,
  'universe-queen': UniverseQueen,
  'truck-and-fins': TruckAndFins,
  'play-on': PlayOn,
  'professional-scopists': ProfessionalScopists,
  washup: Washup,
};

export const caseStudyRouteComponents = caseStudiesData.map((study) => ({
  path: study.path,
  legacyPath: study.legacyPath,
  Component: componentBySlug[study.slug],
}));
